import { ErrorObject } from '../StoreConstants';

export interface GlobalLoadingInitialState {
    enabled: boolean;
}

export default {
    enabled: false,
} as GlobalLoadingInitialState;